import { render, staticRenderFns } from "./TransactionRow.vue?vue&type=template&id=620abea2&"
import script from "./TransactionRow.vue?vue&type=script&lang=js&"
export * from "./TransactionRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports